<template>
  <div >
    <b-table responsive striped hover :items="items"></b-table>
  </div>
</template>

<script>
import PredictionTable from './PredictionTable'
export default {
  name: 'PredictionSummaryTable',
  props:   ['races', 'reloadCount'],
  components: {
  },
  data () {
    return {
      title: 'PredictionSummaryTable',
      items: []
    }
  },
  watch: {
    reloadCount: function() {
      this.loadTable()
    }
  },
  methods: {
    loadTable: function() {
      this.items = []
      var totalReturn = 0
      var advisedBetsReturn = 0
      var notHandicapReturn = 0
      this.races.forEach(race => {
        var betReturn = -1
        if (race.actualWinner || !race.horses) {
          if (race.predictedWinner === race.actualWinner) {
            betReturn = race.predictedWinnerOdds
          }
        }else {
          var predictedWinnerInRace = race.horses.filter(horse => horse.name === race.predictedWinner)[0]
          if (predictedWinnerInRace && predictedWinnerInRace.position === 1) {
            betReturn = race.predictedWinnerOdds
          }
        }
        totalReturn += betReturn
        if (race.meetsBetCriteria()) advisedBetsReturn += betReturn
        if (!race.isHandicap) notHandicapReturn += betReturn
      })

      this.items.push({title: "Overall return", value: totalReturn.toFixed(2)})
      this.items.push({title: "Return on advised bets", value: advisedBetsReturn.toFixed(2)})
      this.items.push({title: "Return on non-Handicaps", value: notHandicapReturn.toFixed(2)})
    }
  },
  mounted () {
    this.loadTable()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
